var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.5 67",
    style: {
      enableBackground: "new 0 0 882.5 67"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{opacity:0.4;}\n\t.st3{fill:#3AAFA9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 882.5,
    height: 67
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "882.5,12.4 882.5,0.1 852.1,0.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "294.6,67 255.3,50.9 269.2,16.9 391.4,67 445.1,67 282,0.1 254,0.1 250.3,9.1 236.4,43.1 228.6,62  226.5,67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "540,0.1 507.2,0.1 496.4,26.3 432.5,0.1 378.7,0.1 488.6,45.1 479.7,67 501.8,67 507.5,52.8 541.9,67  617.6,67 527.6,30.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "793,0.1 771,0.1 768.7,5.5 755.3,0.1 701.6,0.1 761,24.4 747,58.4 604.8,0.1 551.1,0.1 714.4,67  768,67 765.9,66.2 779.9,32.1 864.8,67 882.5,67 882.5,52.1 787.6,13.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarBackground);
export default __webpack_public_path__ + "static/media/navbar_background.bf9b2a04dc78c6ad1c578c43b8737f1f.svg";
export { ForwardRef as ReactComponent };